/**
 * Страница со списком объектов сотрудника
 */
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { SitesList } from '../components/SitesList'
import { BottomNav } from '../components/BottomNav'
import './SitesPage.css'

type NavTab = 'qr' | 'sites' | 'schedule' | 'profile'

export function SitesPage() {
  const navigate = useNavigate()
  const [activeTab] = useState<NavTab>('sites')

  const handleTabChange = (tab: NavTab) => {
    if (tab === 'qr') {
      navigate('/')
    } else if (tab === 'profile') {
      navigate('/profile')
    } else if (tab === 'schedule') {
      navigate('/schedule')
    }
    // sites - уже на этой странице
  }

  return (
    <div className="sites-page">
      <div className="sites-page__header">
        <h1 className="sites-page__title">🏢 Мои объекты</h1>
        <p className="sites-page__subtitle">Список объектов к которым у вас есть доступ</p>
      </div>

      <div className="sites-page__content">
        <SitesList />
      </div>

      <BottomNav activeTab={activeTab} onTabChange={handleTabChange} />
    </div>
  )
}
